import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Input } from 'sfy-react'
import CountryDropdown from '../CountryDropdown'
import { postRequestAsync } from '../../genericAPIs'
import { setAppConfigDetails, setLoader, setSelectedCountryDetails, setSnackbar } from '../../../redux/common'
import { isMobileNumberValid, regex, validateValues } from '../../../utils/form'

const NewUserDetailsForm = ({ handleOnSubmit, closeBtn, showEmail }) => {
  const dispatch = useDispatch()
  const translatedData = useSelector((state) => state.common.translatedData)
  const appConfigDetails = useSelector((state) => state.common.appConfigDetails)
  const selectedCountryDetails = useSelector((state) => state.common.selectedCountryDetails)
  const [fields, setFields] = useState({
    name: '',
  })
  const [errors, setErrors] = useState({})
  const [isDisabled, setIsDisabled] = useState(true)

  useEffect(() => {
    setFields((fields) => ({ ...fields, [appConfigDetails.enableEmailLogin ? 'mobileNumber' : 'email']: '' }))
  }, [appConfigDetails])

  const handleOnChange = (e) => {
    setFields((fields) => ({ ...fields, [e.target.name]: e.target.value }))
  }

  const handleOnMobileNumberChange = (e) => {
    const mobileNumberLengths = selectedCountryDetails.countryConfig?.mobileNumber?.LENGTH || [10]
    if (regex[e.target.name].test(e.target.value) && e.target.value.length <= Math.max(...mobileNumberLengths)) {
      handleOnChange(e)
    }
  }

  const handleOnCountryChange = async (item) => {
    dispatch(setSelectedCountryDetails(item))
    try {
      dispatch(setLoader(true))
      const response = await postRequestAsync('/Consumer/appConfig')
      dispatch(setAppConfigDetails(response))
      dispatch(setLoader(false))
    } catch (e) {
      console.log(e)
      dispatch(setSnackbar({ message: e.msg, type: 'error' }))
      dispatch(setLoader(false))
    }
  }

  const validate = useCallback(() => {
    setErrors({})
    const mobileNumberLengths = selectedCountryDetails.countryConfig?.mobileNumber?.LENGTH || [10]
    const length = Math.max(...mobileNumberLengths)
    const lengths = { mobileNumber: length, alternateMobileNumber: length }
    let isValid = isMobileNumberValid(fields.mobileNumber, window.countryCode, length)
    if (!isValid) {
      setErrors({ mobileNumber: translatedData.error.invalidMobile })
    }
    if (isValid) {
      const formFields = validateValues(fields, {}, lengths)
      isValid = formFields.isValid
    }
    return isValid
  }, [selectedCountryDetails, fields, translatedData])

  useEffect(() => {
    setIsDisabled(!validate())
  }, [validate])

  const CountryValueComponent = useCallback(
    (props) => (
      <div className='country-value-container'>
        <img src={props.value.flagImageURL} alt='' />
        <div className='country-label'>
          <span>{`+${props.value.phoneCode}`}</span>
        </div>
      </div>
    ),
    []
  )

  const CountryOptionComponent = useCallback(
    (props) => (
      <div className='country-value-container'>
        <img src={props.option.flagImageURL} alt='' />
        <div>{`+${props.option.phoneCode}`}</div>
        <div className='country-label'>{props.option.countryName}</div>
      </div>
    ),
    []
  )

  return (
    <>
      <div className='mb8 d-flex justify-between align-center'>
        <h3>{translatedData.login.createProfileTitle}</h3>
        {closeBtn}
      </div>
      <p>{translatedData.login.createProfileSubtext}</p>
      <p>{translatedData.login.createProfileDisclaimer}</p>
      <form onSubmit={(e) => handleOnSubmit(e, fields)} className='mt28'>
        <Input
          id='name'
          name='name'
          value={fields.name}
          placeholder={translatedData.login.inputName}
          label={translatedData.common.name}
          handleOnChange={handleOnChange}
          className={{ inputContainer: 'mb28', label: 'input_label' }}
        />
        <div className='mb20'>
          {!showEmail ? (
            <>
              <div className='title-case input__label'>{translatedData.login.enterMobileNumber}</div>
              <CountryDropdown
                classes={{
                  container: 'mt10',
                  valueContainer: 'country-dropdown-container',
                  optionsSearch: 'pt10 pr10 pb10 pl10',
                }}
                selectedCountry={selectedCountryDetails}
                handleOnCountrySelection={handleOnCountryChange}
                CountryValueComponent={CountryValueComponent}
                CountryOptionComponent={CountryOptionComponent}
                isDisabled={appConfigDetails?.countries?.length === 1}
                error={errors.mobileNumber}
              >
                <Input
                  className={{
                    formControl: 'width-100',
                  }}
                  inputType='text'
                  placeholder={translatedData.common.mobileNumber}
                  autoComplete='on'
                  value={fields.mobileNumber || ''}
                  name='mobileNumber'
                  handleOnChange={handleOnMobileNumberChange}
                />
              </CountryDropdown>
            </>
          ) : (
            <Input
              name='email'
              value={fields.email || ''}
              placeholder={translatedData.login.enterEmailID}
              label={translatedData.common.emailId}
              handleOnChange={handleOnChange}
              className={{ label: 'input__label' }}
            />
          )}
        </div>
        <Button className={'button button-primary mt20'} isDisabled={isDisabled} text={translatedData.common.createProfile}></Button>
      </form>
    </>
  )
}

export default NewUserDetailsForm
